import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";

const BASE = "/api/custom-fields";
const ADMIN = "/api/admin/custom-fields";

export const fetchCustomFieldDefinitions = createAsyncThunk(
  "customFields/fetchDefinitions",
  async (entityType) => {
    const { data } = await localhost.get(`${BASE}/${entityType}`);
    return { entityType, definitions: data };
  }
);

export const createCustomFieldDefinition = createAsyncThunk(
  "customFields/createDefinition",
  async ({ entityType, payload }, { rejectWithValue }) => {
    try {
      const { data } = await localhost.post(`${ADMIN}/${entityType}`, payload);
      return { entityType, definition: data };
    } catch (err) {
      return rejectWithValue({
        status: err.response?.status,
        ...err.response?.data,
      });
    }
  }
);

export const updateCustomFieldDefinition = createAsyncThunk(
  "customFields/updateDefinition",
  async ({ entityType, fieldId, payload }, { rejectWithValue }) => {
    try {
      const { data } = await localhost.put(
        `${ADMIN}/${entityType}/${fieldId}`,
        payload
      );
      return { entityType, definition: data };
    } catch (err) {
      return rejectWithValue({
        status: err.response?.status,
        ...err.response?.data,
      });
    }
  }
);

export const deleteCustomFieldDefinition = createAsyncThunk(
  "customFields/deleteDefinition",
  async ({ entityType, fieldId }, { rejectWithValue }) => {
    try {
      await localhost.delete(`${ADMIN}/${entityType}/${fieldId}`);
      return { entityType, fieldId };
    } catch (err) {
      return rejectWithValue({
        status: err.response?.status,
        ...err.response?.data,
      });
    }
  }
);

export const fetchDeletePreview = createAsyncThunk(
  "customFields/fetchDeletePreview",
  async ({ entityType, fieldId }, { rejectWithValue }) => {
    try {
      const { data } = await localhost.get(
        `${ADMIN}/${entityType}/${fieldId}/delete-preview`
      );
      return data;
    } catch (err) {
      return rejectWithValue({
        status: err.response?.status,
        ...err.response?.data,
      });
    }
  }
);

export const reorderCustomFieldDefinitions = createAsyncThunk(
  "customFields/reorderDefinitions",
  async ({ entityType, fieldIds }, { rejectWithValue }) => {
    try {
      const { data } = await localhost.put(`${ADMIN}/${entityType}/order`, {
        fieldIds,
      });
      return { entityType, definitions: data };
    } catch (err) {
      return rejectWithValue({
        status: err.response?.status,
        ...err.response?.data,
      });
    }
  }
);
